import { useState } from "react";

interface Props {
  initialText: string;
  onBack: () => void;
  onStart: (text: string) => void;
}

export function TextReview({ initialText, onBack, onStart }: Props) {
  const [text, setText] = useState(initialText);
  const charCount = text.length;

  return (
    <div className="app">
      <div className="top-bar">
        <button className="icon-btn" onClick={onBack} aria-label="Back">
          ←
        </button>
        <div>
          <strong>Review text</strong>
          <div className="reader-sub">{charCount.toLocaleString()} characters</div>
        </div>
      </div>

      <textarea
        className="editor"
        value={text}
        onChange={(e) => setText(e.target.value)}
        style={{ flex: 1 }}
      />

      <div style={{ height: 14 }} />

      <button className="btn btn-primary btn-block" disabled={!text.trim()} onClick={() => onStart(text)}>
        Start reading
      </button>
    </div>
  );
}
